import { Tooltip } from "react-migration/components/Tooltip";
import { Theme } from "react-migration/lib/theme/Theme";

interface InsightSelectedAreaWithTooltipProps {
  children?: string;
}

export const InsightSelectedAreaWithTooltip = ({ children }: InsightSelectedAreaWithTooltipProps) => {
  if (!children) return null;

  return (
    <div>
      <Tooltip.Wrapper>
        <Tooltip.Content size="sm" side="top" align="center" theme={Theme.Light}>
          <Tooltip.Description>
            A site may have multiple overlapping areas. The insights shown will represent the largest area of overlap.
          </Tooltip.Description>
        </Tooltip.Content>
        <Tooltip.Trigger>
          <p className="text-xs mt-[10px] inline-flex max-w-full gap-x-1">
            <span className="text-text-base-primary cursor-default truncate" title={children}>
              {children}
            </span>
            <i className="icon-lt-information-line text-text-base-secondary-a print:hidden" />
          </p>
        </Tooltip.Trigger>
      </Tooltip.Wrapper>
    </div>
  );
};
